import script from "./PopupAppointment.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopupAppointment.vue?vue&type=script&lang=ts&setup=true"

import "./PopupAppointment.vue?vue&type=style&index=0&id=c01703f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c01703f6"]])

export default __exports__